import { Link } from 'react-router-dom'
import MainLayout from "../layouts/MainLayout";

const NotFound = () => {
    return (
        <MainLayout className="flex items-center">
            <div className="flex-1 flex flex-col items-center justify-center text-center">
                {/* Giant 404 */}
                <div
                    className="select-none leading-none"
                    style={{
                        fontFamily: "'Archivo Black', sans-serif",
                        fontSize: 'clamp(8rem, 30vw, 22rem)',
                        letterSpacing: '-0.05em',
                        color: '#FFE135',
                        WebkitTextStroke: '3px #0A0A0A',
                        lineHeight: 1,
                    }}
                >
                    404
                </div>

                {/* Label */}
                <div
                    className="mt-4 px-5 py-2 border-2 border-black nb-shadow inline-block"
                    style={{ backgroundColor: '#FF3B3B', fontFamily: "'DM Mono', monospace", color: '#fff', fontSize: '0.75rem', letterSpacing: '0.15em' }}
                >
                    PAGE NOT FOUND
                </div>

                <p
                    className="mt-8 text-base max-w-md leading-relaxed"
                    style={{ color: '#555' }}
                >
                    Whatever you were looking for isn't here. Maybe it moved, maybe it never existed. Either way — let's get you back somewhere useful.
                </p>

                {/* Actions */}
                <div className="mt-10 flex flex-wrap gap-4 justify-center">
                    <Link
                        to="/"
                        className="px-8 py-4 bg-black text-white border-2 border-black font-semibold text-base nb-shadow-lg nb-hover"
                        style={{ fontFamily: "'Archivo Black', sans-serif", letterSpacing: '0.04em' }}
                    >
                        ← HOME
                    </Link>
                    <Link
                        to="/#work"
                        className="px-8 py-4 border-2 border-black font-semibold text-base nb-shadow nb-hover"
                        style={{ backgroundColor: '#B4FF39' }}
                    >
                        VIEW WORK →
                    </Link>
                </div>

                {/* Decorative grid of project links */}
                <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-3 w-full max-w-2xl">
                    {[
                        { id: 'kova', label: 'Kova', color: '#FFE135' },
                        { id: 'pulse', label: 'Pulse', color: '#B4FF39' },
                        { id: 'drift', label: 'Drift', color: '#3B82FF' },
                        { id: 'forma', label: 'Forma', color: '#FF3B3B' },
                    ].map(({ id, label, color }) => (
                        <Link
                            key={id}
                            to={`/project/${id}`}
                            className="px-4 py-3 border-2 border-black text-sm font-semibold nb-shadow nb-hover text-center"
                            style={{ backgroundColor: color, color: '#0A0A0A', fontFamily: "'DM Mono', monospace" }}
                        >
                            {label} ↗
                        </Link>
                    ))}
                </div>
                <p className="mt-3 text-xs" style={{ fontFamily: "'DM Mono', monospace", color: '#aaa' }}>
                    or jump straight to a project
                </p>
            </div>
        </MainLayout>
    )
}

export default NotFound
